import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

// Containers
import Full from '@/containers/Full'

// Views
import dashboard from '@/views/components/dashboard'
import Login from '@/views/components/login'
import changepassword from '@/views/components/changepassword'
import trackshipmentsummary from '@/views/components/trackshipmentsummary'
import trackshipmentsummarydetail from '@/views/components/trackshipmentsummary'
import trackshipmentsummarybytype from '@/views/components/trackshipmentsummary'
import bulkshipment from '@/views/components/bulkshipment'
import csawshipments from '@/views/components/CSAWShipments'
import holdbucket from '@/views/components/holdbucket'

import callpatching from '@/views/components/callpatching'
import allReports from '@/views/components/allReports'
import emailr from '@/views/components/emailr'
import tlDashboard from '@/views/components/emailr/tlDashboard'
import agentdashboard from '@/views/components/emailr/agentdashboard'
import blockunblockemail from '@/views/components/emailr/blockunblockemail'

import EmailrUserDashboard from '@/views/components/emailr/EmailrUserDashboard'
import emailtracking from '@/views/components/emailr/emailtracking'
import emailCaseLog from '@/views/components/emailr/emailCaseLog'
import EmailPreview from '@/views/components/emailr/EmailPreview'
import EmailPreviewRaiseTicket from '@/views/components/emailr/EmailPreviewRaiseTicket'
import emailattachment from '@/views/components/emailr/emailattachment'
import trackingemailtracking from '@/views/components/emailr/trackingemailtracking'

//B2B Components
import b2bdashboard from '@/views/components/b2b/b2bdashboard'
import b2btrackshipment from '@/views/components/b2b/trackshipment'
import b2btrackshipmentdetail from '@/views/components/b2b/trackshipment'
import cargoappointment from '@/views/components/cargoappointment'
import bulkshipmentaction from '@/views/components/b2b/bulkshipmentaction'

import ndr from '@/views/components/ndr'
import adi from '../views/components/adi'
import coddialer from '@/views/components/coddialer'

// Views - Components
import Buttons from '@/views/components/Buttons'
import SocialButtons from '@/views/components/SocialButtons'
import Cards from '@/views/components/Cards'
import Forms from '@/views/components/Forms'
import Modals from '@/views/components/Modals'
import Switches from '@/views/components/Switches'
import Tables from '@/views/components/Tables'
import test from '@/views/test'
import Charts from '@/views/Charts'
import Widgets from '@/views/Widgets'
import CryptoJS from 'crypto-js';


// Views - Icons
import FontAwesome from '@/views/icons/FontAwesome'
import SimpleLineIcons from '@/views/icons/SimpleLineIcons'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'

import apiUrl from '../constants'
import commonFunction from '../commonFunction'
import keycloak from '../Keycloak'; // Import the keycloak instance

Vue.use(Router)
const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [{
          path: 'dashboard',
          name: 'dashboard',
          component: dashboard,
          meta: {
            title: 'Dashboard - ' + apiUrl.project_name,
            metaTags: [{
              name: 'description',
              content: 'The home page of our example app.'
            }],
            requiresAuth: true,
            breadcrumb: [{
                name: 'Dashboard',
                link: '/dashboard'
              },
              {
                name: 'Dashboard'
              }
            ]
          },
        },
        {
          path: '/changepassword',
          name: 'changepassword',
          component: changepassword,
          meta: {
            //requiresAuth: true,
            breadcrumb: [{
                name: 'Home',
                link: '/changepassword'
              },
              {
                name: 'Change Password'
              }
            ]
            //	adminAuth: "changepassword"
          }
        },
        {
          path: '/test',
          name: 'test',
          component: test,
          meta: {
            //requiresAuth: true,
            breadcrumb: [{
                name: 'Home',
                link: '/test'
              },
              {
                name: 'Change Password'
              }
            ]
            //	adminAuth: "changepassword"
          }
        },
        {
          path: 'trackshipmentsummary',
          name: 'trackshipmentsummary',
          component: trackshipmentsummary,
          meta: {
            title: 'Trackshipment Summery - ' + apiUrl.project_name,
            metaTags: [{
              name: 'description',
              content: 'The home page of our example app.'
            }],
            requiresAuth: true,
            breadcrumb: [{
                name: 'Trackshipmentsummary',
                link: '/trackshipmentsummary'
              },
              {
                name: 'Trackshipmentsummary'
              }
            ]
          },
        },
        {
          path: 'trackshipmentsummarydetail/:id',
          name: 'trackshipmentsummarydetail',
          component: trackshipmentsummary,
          meta: {
            title: 'Trackshipment Summery - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
                name: 'Trackshipmentsummary',
                link: '/trackshipmentsummarydetail'
              },
              {
                name: 'Trackshipmentsummary'
              }
            ]
          },
        },
        {
          path: 'trackshipmentsummarybytype/:type/:id',
          name: 'trackshipmentsummarybytype',
          component: trackshipmentsummary,
          meta: {
            title: 'Trackshipment Summery - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
                name: 'Trackshipmentsummary',
                link: '/trackshipmentsummarybytype'
              },
              {
                name: 'Trackshipmentsummary'
              }
            ]
          },
        },
        {
          path: 'callpatching',
          name: 'callpatching',
          component: callpatching,
          meta: {
            title: 'Call Patching - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
                name: 'CallPatching',
                link: '/callpatching'
              },
              {
                name: 'Logistics Call Patching Panel'
              }
            ]
          },
        },
        {
          path: 'bulkshipment',
          name: 'bulkshipment',
          component: bulkshipment,
          meta: {
            title: 'Bulk Shipment - ' + apiUrl.project_name,
            metaTags: [{
              name: 'description',
              content: 'The home page of our example app.'
            }],
            requiresAuth: true,
            breadcrumb: [{
                name: 'Bulk Shipment',
                link: '/bulkshipment'
              },
              {
                name: 'Bulk Shipment'
              }
            ]
          },
        },
        {
          path: 'csawshipments',
          name: 'csawshipments',
          component: csawshipments,
          meta: {
            title: 'Process CSAW Shipments - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            }, {
              name: 'CSAWShipments',
              link: '/csawshipments'
            }]
          },
        },  
        {
          path: 'holdbucket',
          name: 'holdbucket',
          component: holdbucket,
          meta: {
            title: 'Hold Bucket - ' + apiUrl.project_name,
            requiresAuth: true,
          },
        }, 
        {
          path: 'b2b/trackshipment',
          name: 'b2btrackshipment',
          component: b2btrackshipment,
          meta: {
            title: 'B2B Track Shipment - ' + apiUrl.project_name,
            requiresAuth: true,
metaTags: [{
              name: 'description',
              content: 'The home page of our example app.'
            }],
            breadcrumb: [{
              name: 'Home',
              link: '/b2b/trackshipment'
            }, {
              name: 'b2btrackshipment',
              link: '/b2b/trackshipment'
            }]
          },
        },
        {
          path: 'b2b/bulkshipment',
          name: 'bulkshipmentaction',
          component: bulkshipmentaction,
          meta: {
            title: 'B2B Track Shipment - ' + apiUrl.project_name,
            requiresAuth: true,
metaTags: [{
              name: 'description',
              content: 'The home page of our example app.'
            }],
            // breadcrumb: [{
            //   name: 'Home',
            //   link: '/b2b/trackshipment'
            // }, {
            //   name: 'b2btrackshipment',
            //   link: '/b2b/trackshipment'
            // }]
          },
        },
        {
          path: 'b2b/trackshipment/:id',
          name: 'b2btrackshipmentdetail',
          component: b2btrackshipment,
          meta: {
            title: 'B2B Track Shipment - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'b2btrackshipment',
              link: '/b2btrackshipmentdetail'
            }, {
              name: 'b2btrackshipment',
            }]
          },
        },
        {
          path: 'b2b/dashboard',
          name: 'b2bdashboard',
          component: b2bdashboard,
          meta: {
            title: 'B2B Dashboard - ' + apiUrl.project_name,
            requiresAuth: true,
metaTags: [{
              name: 'description',
              content: 'The home page of our example app.'
            }],
            breadcrumb: [{
              name: 'Home',
              link: 'b2b/dashboard'
            }, {
              name: 'b2bdashboard',
              link: '/b2b/dashboard'
            }]
          },
        },

        {
          path: 'cargoappointment',
          name: 'cargoappointment',
          component: cargoappointment,
          meta: {
            title: 'Cargo Appointment Date - ' + apiUrl.project_name,
            requiresAuth: true,
metaTags: [{
              name: 'description',
              content: 'The home page of our example app.'
            }],
            breadcrumb: [{
              name: 'Home',
              link: '/cargoappointment'
            }, {
              name: 'cargoappointment',
              link: '/cargoappointment'
            }]
          },
        },
       {
          path: 'allReports',
          name: 'allReports',
          component: allReports,
          meta: {
            title: 'Process CSAW Shipments - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            }, {
              name: 'allReports',
              link: '/allReports'
            }]
          },
        },
        {
          path: 'emailr-system',
          name: 'emailr',
          component: emailr,
          meta: {
            title: 'Emailer System - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            }, {
              name: 'Emailer System',
              link: '/emailr-system'
            }]
          },
        },
        {
          path: 'tldashboard',
          name: 'TL Dashboard',
          component: tlDashboard,
          meta: {
            title: 'tldashboard - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            }, {
              name: 'TL Dashboard',
              link: '/tlDashboard'
            }]
          },
        },
        {
          path: 'agentdashboard',
          name: 'Agent Dashboard',
          component: agentdashboard,
          meta: {
            title: 'Agent Dashboard - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            }, {
              name: 'Agent Dashboard',
              link: '/agentdashboard'
            }]
          },
        },
        {
          path: 'ndr',
          name: 'ndr',
          component: ndr,
          meta: {
            title: 'ndr - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            }, {
              name: 'ndr',
              link: '/ndr'
            }]
          },
        },
        {
          path: 'adi/:alias',
          name: 'adi',
          component: adi,
          meta: {
            title: 'adi - ' + apiUrl.project_name,
            requiresAuth: false,
            adi: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            }, {
              name: 'adi',
              link: "/adi"
            }]
          },
        },
        {
          path: 'coddialer',
          name: 'coddialer',
          component: coddialer,
          meta: {
            title: 'coddialer - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            }, {
              name: 'coddialer',
              link: '/coddialer'
            }]
          },
        },
        {
          path: 'blockunblockemail',
          name: 'Block Unblock Email',
          component: blockunblockemail,
          meta: {
            title: 'Block unblock Email - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            },{
              name: 'Emailer System',
              link: '/emailr-system'
            }, {
              name: 'Block unblock Email',
              link: '/blockunblockemail'
            }]
          },
        },
        {
          path: 'EmailrUserDashboard',
          name: 'Emailr User Dashboard',
          component: blockunblockemail,
          meta: {
            title: 'Emailer User Dashboard - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            },{
              name: 'Emailer System',
              link: '/emailr-system'
            }, {
              name: 'Block unblock Email',
              link: '/EmailrUserDashboard'
            }]
          },
        },
        {
          path: 'emailtracking',
          name: 'Emailr Tracking',
          component: emailtracking,
          meta: {
            title: 'Email Tracking - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            },{
              name: 'Emailer System',
              link: '/emailr-system'
            }, {
              name: 'Email Tracking',
              link: '/emailtracking'
            }]
          },
        },
        {
          path: 'trackingemailtracking',
          name: 'Emailr Tracking',
          component: trackingemailtracking,
          meta: {
            title: 'Email Tracking - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            },{
              name: 'Emailer System',
              link: '/emailr-system'
            }, {
              name: 'Email Tracking',
              link: '/emailtracking'
            }]
          },
        },
        {
          path: 'emailCaseLog',
          name: 'Email Case Log',
          component: emailCaseLog,
          meta: {
            title: 'Email Case log - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            },{
              name: 'Emailer System',
              link: '/emailr-system'
            },{
              name: 'Email Case Log',
              link: '/emailCaseLog'
            }]
          },
        },
        {
          path: 'EmailPreview',
          name: 'Email Preview',
          component: EmailPreview,
          meta: {
            title: 'Email Preview - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            },{
              name: 'Emailer System',
              link: '/emailr-system'
            },{
              name: 'Email Tracking',
              link: '/emailtracking'
            }, {
              name: 'Email Preview',
              link: '/EmailPreview'
            }]
          },
        },
                {
          path: 'EmailPreviewRaiseTicket',
          name: 'Email Preview Raise Ticket',
          component: EmailPreviewRaiseTicket,
          meta: {
            title: 'Email Preview - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            },{
              name: 'Emailer System',
              link: '/emailr-system'
            },{
              name: 'Email Tracking',
              link: '/emailtracking'
            }, {
              name: 'Email Preview',
              link: '/EmailPreviewRaiseTicket'
            }]
          },
        },
        {
          path: 'emailattachment',
          name: 'Email Attachment',
          component: emailattachment,
          meta: {
            title: 'Email Attachment - ' + apiUrl.project_name,
            requiresAuth: true,
            breadcrumb: [{
              name: 'Home',
              link: '/dashboard'
            }, {
              name: 'Emailer System',
              link: '/emailr-system'
            },{
              name: 'Email Tracking',
              link: '/emailtracking'
            },{
              name: 'Email Attachment',
              link: '/emailattachment'
            }]
          },
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        }
      ]
    },

    {
      path: '/login/:ssotoken?',
      name: 'login',
      component: Login,
      meta: {
        title: 'Home - ' + apiUrl.project_name,
            },
    },
    {
      path: '/pages',
      redirect: '/pages/p404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'test',
          name: 'test',
          component: test
        }
      ]
    },

  ]
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {

  // Start Page Title Logic
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));
  // End Page Title Logic

//console.log("window ",window.localStorage);
//console.log("window.localStorage.getItem('isLoggedIn'); ",window.localStorage.getItem('isLoggedIn'));

  var isLoggedIn = window.localStorage.getItem('isLoggedIn');
  if (isLoggedIn == null) {
    isLoggedIn = false;
  } else {
    isLoggedIn = true;
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({
      path: "/login",
    });
  } else {
    if (to.matched.some(record => record.meta.adminAuth)) {

      // console.log(to.meta.adminAuth);
      var setrole = false;
      // const role = window.localStorage.getItem('role');
      var permissionEncrypt = window.localStorage.getItem('permissiondata')
      var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var permissiondata = JSON.parse(plaintext);
      //console.log(permissiondata);
      for (var i = 0; i < permissiondata.length; i++) {
        if (permissiondata[i].mainmenu == to.meta.adminAuth) {
          setrole = true;
          break;
        } else {
          setrole = false
        }
      }
      if (setrole) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    } else {
      next();
    }
  }

  // Call checkAndClearLocalStorageIfMissed at the end after all routing logic
  keycloak.checkAndClearLocalStorageIfMissed();

});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js